<template>
  <main class="queryDetail container-fluid mf_container pb_50 mb_20">
    <div class="row mt_15">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-default" @click="goback()">重新搜尋</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="selectInsered" v-if="is_crm == '1'">
          <h4 class="d-flex align-items-center">
            請選擇被保險人:
            <div class="text-red ml_8" style="font-size: 13px">
              需建議書無停售商品，才能使用業績換算查詢功能
            </div>
          </h4>

          <div class="selectInsered__list pt_7">
            <div
              class="inseredTab mr_5 mb_10"
              :class="{ active: people.csidno == nowShowInsuredId }"
              @click="changeShowInsured(people)"
              v-for="people in getAllFamilyResult"
              :key="people.csidno"
            >
              <Avatar
                class="mr-2"
                :gender="Number(people.sex)"
                :size="20"
                :height="20"
              />
              <div class="inseredTab__name">{{ truncate(people.name) }}</div>
            </div>
          </div>
        </div>
        <!-- 傳統列表 -->
        <div v-if="proposalDetailList_TD.length > 0">
          <div class="queryDetail__title mt_10">
            <div
              class="queryDetail__title--tag"
              style="background-color: #027a39"
            ></div>
            <h5>傳統型商品</h5>
          </div>
          <QueryContractItemTD
            v-for="(contractItem, index) in proposalDetailList_TD"
            :NO="proposalDetailList_TD.length - index"
            :key="contractItem.prod_idx"
            :contractData="contractItem"
            selectedMode="radio"
            :selected="nowSelectProposal"
            @selectConTractData="selectContractDateHandler($event)"
            :isChecked.sync="contractItem.is_checked"
          ></QueryContractItemTD>
        </div>
        <!-- <div v-if="proposalDetailList_IV.length > 0">
          <div class="queryDetail__title mt_10">
            <div
              class="queryDetail__title--tag"
              style="background-color: #a0a0f0"
            ></div>
            <h5>投資型商品</h5>
          </div>
          <QueryContractItemIV
            v-for="(contractItem, index) in proposalDetailList_IV"
            :NO="proposalDetailList_IV.length - index"
            :key="contractItem.prod_idx"
            :contractData="contractItem"
            selectedMode="radio"
            :selected ="nowSelectProposal"
            @selectConTractData="selectContractDateHandler($event)"
            :isChecked.sync="contractItem.is_checked"
          ></QueryContractItemIV>
        </div> -->
        <div
          class="queryDetail__empty"
          v-if="proposalDetailList_TD.length == 0"
        >
          {{ emptyText }}
        </div>
      </div>
    </div>
    <ChangePopup
      :crmMapList="crmMapList"
      :oldCrmMapList="oldCrmMapList"
      v-if="changePopupHandler"
      @cancel="changePopupHandler = false"
      @finish="toHandler"
    />
    <FixedBottom v-show="proposalDetailList_TD.length > 0">
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-default px_5 mr_10"
            type="button"
            @click="performaceTable()"
            :disabled="isDisable"
          >
            業績換算
          </button>
        </div>
      </template>
    </FixedBottom>
  </main>
</template>

<script>
import { getAllFamily } from "@/service";
import _ from "lodash";
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import QueryContractItemTD from "@/desktop/views/mf/components/QueryContractItem_TD";
// import QueryContractItemIV from "@/desktop/views/mf/components/QueryContractItem_IV";

import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import ChangePopup from "@/desktop/views/mf/components/2.Query/2-3-1.QueryDetail/ChangePopup.vue";
import { computeAge } from "@/service";
export default {
  mixins: [mf_Mixin],
  components: {
    Avatar,
    QueryContractItemTD,
    // QueryContractItemIV,
    FixedBottom,
    ChangePopup,
  },
  data() {
    return {
      getAllFamilyResult: [], //加戶列表
      proposalDetailList_TD: [], //傳統型列表
      // proposalDetailList_IV: [], //投資型列表
      nowShowInsuredId: "", //目前檢視的被保人ID
      nowSelectProposal: null,
      tempNowSelectProposal: null, //已壓上新資料重算，但不確定是user是否使用的暫存
      emptyText: "查詢中...",
      crmMapList: {},
      oldCrmMapList: {}, //出現差異的人們
      changePopupHandler: false,
      isDisable: true,
      toHandler: () => {},
    };
  },
  computed: {
    is_crm() {
      return this.$store.getters.QueryDetailTarget.is_crm;
    },
    insured_id() {
      return this.$store.getters.QueryDetailTarget.insured_id;
    },
    prod_idx() {
      return this.$store.getters.QueryDetailTarget.prod_idx;
    },
    familyid() {
      return this.$store.getters.QueryDetailTarget.familyid;
    },
  },
  beforeCreate() {},
  created() {
    if (this.$store.getters.QueryDetailTarget.is_crm == "") {
      return this.$router.replace("/mf/performace");
    }
    this.init();
  },
  methods: {
    async init() {
      if (this.is_crm == "1") {
        const result = await getAllFamily(
          this.$store.state.userInfo.id,
          this.familyid,
          this.$store.getters.IsBankUser
        );
        this.getAllFamilyResult = result.data;
        this.crmMapList = {}; //家戶現況原始資料
        result.data.forEach((item) => {
          this.crmMapList[item.csidno] = {
            insured_name: item.name,
            insured_birthday: item.birthday || "",
            insured_gender: item.sex,
            insured_age: item.age + "",
          };
        });
        this.nowShowInsuredId = this.insured_id;
      } else {
        this.nowShowInsuredId = this.insured_id;
      }
      this.getProposalDetailList();
    },
    async getProposalDetailList() {
      this.$store.commit("update_mfLoadingMask", true);
      try {
        //傳統型呼叫
        let res_TD = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
          agent_id: this.$store.state.userInfo.id,
          insured_id: this.nowShowInsuredId,
          prod_idx: this.prod_idx,
        });
        this.proposalDetailList_TD = res_TD.proposal;
        //投資型呼叫
        // let res_IV = await this.$mfAPI.MFA1_1000__queryProposalDetailList({
        //   agent_id: this.$store.state.userInfo.id,
        //   insured_id: this.nowShowInsuredId,
        //   prod_idx: this.prod_idx
        // });
        // this.proposalDetailList_IV = res_IV.proposal;

        //呼叫完成後
        this.$store.commit("update_mfLoadingMask", false);
        this.emptyText = "尚未為客戶新增建議書，故無可查詢資訊";
        setTimeout(() => {
          this.registerHanlink();
        }, 500);
      } catch {
        this.$store.commit("update_mfLoadingMask", false);
      }
    },
    changeShowInsured(people) {
      this.proposalDetailList_TD = [];
      this.proposalDetailList_IV = [];
      this.emptyText = "查詢中...";
      this.nowShowInsuredId = people.csidno;
      this.getProposalDetailList();
    },
    goback() {
      this.$router.push(`/mf/performace${this.is_crm == "0" ? "?noId=1" : ""}`);

      this.$store.commit("reset_Customer");
      this.getAllFamilyResult = [];
      this.proposalDetailList_TD = [];
      this.proposalDetailList_IV = [];
    },
    async performaceTable() {
      // <------- 產生要換算商品清單 ------>
      if (this.nowSelectProposal.mc_prod_list.length === 0) {
        return this.$toast.info({ title: `請先選擇一組建議!` });
      }

      // <------- 已勾選產品清單 ------>
      let tempNowSelectProposal = _.cloneDeep(this.nowSelectProposal);
      //$空白建議書，增齡機制
      var isAddAge_noId = false;
      if (
        tempNowSelectProposal.insured_id == "" &&
        tempNowSelectProposal.insured_birthday
      ) {
        let res_new_insured_age = await computeAge(
          this.$store.state.userInfo.id,
          moment(tempNowSelectProposal.insured_birthday).format("YYYY-MM-DD")
        );
        if (
          parseInt(res_new_insured_age.body.age) !=
          parseInt(tempNowSelectProposal.insured_age)
        ) {
          isAddAge_noId = true;
        }
      }
      if (
        tempNowSelectProposal.insured_id == "" &&
        tempNowSelectProposal.insurer_birthday &&
        !isAddAge_noId
      ) {
        let res_new_insurer_age = await computeAge(
          this.$store.state.userInfo.id,
          moment(tempNowSelectProposal.insurer_birthday).format("YYYY-MM-DD")
        );
        if (
          parseInt(res_new_insurer_age.body.age) !=
          parseInt(tempNowSelectProposal.insurer_age)
        ) {
          isAddAge_noId = true;
        }
      }

      // <------- 停售商品 ------>
      let isStopSale = false;
      let autoDeleteSet = new Set(); //資動刪除清單，提示用

      for (let i = 0; i < tempNowSelectProposal.mc_prod_list.length; i++) {
        let mc = tempNowSelectProposal.mc_prod_list[i];
        mc.riskObj = this.kycRiskObjText;
        if (typeof mc.fund == "string") {
          mc.fund = JSON.parse(mc.fund);
        }
        if (mc.stop_sale == "1") {
          isStopSale = true;
          tempNowSelectProposal.mc_prod_list.splice(i, 1);
          autoDeleteSet.add(`${mc.prod_name}(${mc.prod_id})`);
          i--;
          continue;
        }
        for (let j = 0; j < mc.sc_prod_list.length; j++) {
          let sc = mc.sc_prod_list[j];
          sc.is_checked = "1";
          if (sc.stop_sale == "1") {
            isStopSale = true;
            mc.sc_prod_list.splice(j, 1);
            autoDeleteSet.add(`${sc.prod_name}(${sc.prod_id})`);
            j--;
          } else if (
            tempNowSelectProposal.insured_id == "" &&
            sc.insured_birthday &&
            !isAddAge_noId
          ) {
            //空白建議書，要額外判斷增齡，若該商品被停售，則不判斷，因此放在這
            let res_new_insured_age = await computeAge(
              this.$store.state.userInfo.id,
              moment(sc.insured_birthday).format("YYYY-MM-DD")
            );
            if (
              parseInt(res_new_insured_age.body.age) != parseInt(sc.insured_age)
            ) {
              isAddAge_noId = true;
            }
          }
        }
      }
      if (isStopSale) {
        return this.$mfNotice(
          "本份建議書包含已停售商品!",
          null,
          false,
          null,
          "確定",
          "依本公司商品銷售文件規範，商品建議書僅可作為行銷時協助客戶了解商品內容之輔助說明文件，故商品停售後，建議書及內含之各試算數值均不得繼續產製、匯入行動投保等操作。 <br><br>如欲刪除停售商品，點擊「修改建議書」刪除該商品。"
        );
      } else if (isAddAge_noId) {
        return this.$mfNotice(
          "本份建議書的試算客戶已增齡!",
          null,
          false,
          null,
          "確定",
          "客戶已增齡，請至「新增/輸入」頁籤重新試算"
        );
      }

      let mode = "";

      let to = (tempNowSelectProposal) => {
        return () => {
          this.changePopupHandler = false;
          let proposalData = {
            No: tempNowSelectProposal.NO,
            prod_idx: tempNowSelectProposal.prod_idx,
            insured: {
              insured_age: tempNowSelectProposal.insured_age,
              insured_birthday: tempNowSelectProposal.insured_birthday,
              insured_gender: tempNowSelectProposal.insured_gender,
              insured_id: tempNowSelectProposal.insured_id,
              insured_name: tempNowSelectProposal.insured_name,
            },
            insurer: {
              insured_age: tempNowSelectProposal.insurer_age,
              insured_birthday: tempNowSelectProposal.insurer_birthday,
              insured_gender: tempNowSelectProposal.insurer_gender,
              insured_id: tempNowSelectProposal.insurer_id,
              insured_name: tempNowSelectProposal.insurer_name,
            },
            inputType:
              tempNowSelectProposal.insurer_id == "" ? "noId" : "family",
            sameInsurer:
              tempNowSelectProposal.insurer_id ===
              tempNowSelectProposal.insured_id,
            mc_prod_list: tempNowSelectProposal.mc_prod_list,
            sc_prod_id_list: tempNowSelectProposal.sc_prod_id_list,
          };
          let family = this.getAllFamilyResult.find((item) => {
            return item.csidno == this.nowShowInsuredId;
          });
          this.$store.commit("update_MfViewing", {
            ...proposalData,
            prod_idx: proposalData.prod_idx,
            saveData: tempNowSelectProposal,
            familyid: (family && family.familyid) || "",
          });
          this.$store.commit("update_queryDetailTarget", {
            is_crm: this.is_crm,
            insured_id: tempNowSelectProposal.insured_id,
            prod_idx: this.is_crm == "0" ? this.prod_idx : "",
            familyid: (family && family.familyid) || "",
          });
          this.$store.commit(
            "set_performaceQueryList",
            _.cloneDeep(tempNowSelectProposal)
          );
          if (mode == "edit") {
            this.$store.commit("update_MfEditing", proposalData);
            this.$router.push("/mf/create");
          }
        };
      };

      let customStatusCheck = async () => {
        this.oldCrmMapList = {};
        let needShowChangePopup = false;
        let crmMapList = this.crmMapList;
        //開始判斷建議書資料對比，要保人 insurer_id
        let insurer_id = this.nowSelectProposal.insurer_id;
        if (!crmMapList[insurer_id]) {
          //被保人離開不在這個家戶 因此做例外處理
          let theCust = await getCustInfo(
            this.$store.state.userInfo.id,
            this.$store.state.userInfo.id,
            insurer_id
          );
          if (theCust.body.customer) {
            //有找到
            crmMapList[insurer_id] = {
              insured_name: theCust.body.customer.name,
              insured_birthday: theCust.body.customer.birthday || "",
              insured_gender: theCust.body.customer.sex,
              insured_age: theCust.body.customer.age + "",
            };
          } else {
            //找不到
            this.$toast.info({
              title: `${this.nowSelectProposal.insurer_name}找不到資料`,
            });
          }
        }
        if (
          tempNowSelectProposal.insurer_name !=
            crmMapList[insurer_id].insured_name ||
          tempNowSelectProposal.insurer_gender !=
            crmMapList[insurer_id].insured_gender ||
          tempNowSelectProposal.insurer_age !=
            crmMapList[insurer_id].insured_age ||
          (tempNowSelectProposal.insurer_birthday || "") !=
            crmMapList[insurer_id].insured_birthday
        ) {
          needShowChangePopup = true;
          this.oldCrmMapList[insurer_id] = {
            insured_name: tempNowSelectProposal.insurer_name,
            insured_birthday: tempNowSelectProposal.insurer_birthday || "",
            insured_gender: tempNowSelectProposal.insurer_gender,
            insured_age: tempNowSelectProposal.insurer_age + "",
            is_insurer: true,
          };
          //更新建議書資訊
          tempNowSelectProposal.insurer_name =
            crmMapList[insurer_id].insured_name;
          tempNowSelectProposal.insurer_gender =
            crmMapList[insurer_id].insured_gender;
          tempNowSelectProposal.insurer_age =
            crmMapList[insurer_id].insured_age;
          tempNowSelectProposal.insurer_birthday =
            crmMapList[insurer_id].insured_birthday;
        }
        //開始判斷建議書資料對比，主約被保人 insured_id
        let mcInsured_id = this.nowSelectProposal.insured_id;
        if (
          tempNowSelectProposal.insured_name !=
            crmMapList[mcInsured_id].insured_name ||
          tempNowSelectProposal.insured_gender !=
            crmMapList[mcInsured_id].insured_gender ||
          tempNowSelectProposal.insured_age !=
            crmMapList[mcInsured_id].insured_age ||
          tempNowSelectProposal.insured_gender !=
            crmMapList[mcInsured_id].insured_gender ||
          (tempNowSelectProposal.insured_birthday || "") !=
            crmMapList[mcInsured_id].insured_birthday
        ) {
          needShowChangePopup = true;
          this.oldCrmMapList[mcInsured_id] =
            this.oldCrmMapList[mcInsured_id] || {};
          this.oldCrmMapList[mcInsured_id].insured_name =
            tempNowSelectProposal.insured_name;
          this.oldCrmMapList[mcInsured_id].insured_birthday =
            tempNowSelectProposal.insured_birthday || "";
          this.oldCrmMapList[mcInsured_id].insured_gender =
            tempNowSelectProposal.insured_gender;
          this.oldCrmMapList[mcInsured_id].insured_age =
            tempNowSelectProposal.insured_age + "";
          this.oldCrmMapList[mcInsured_id].is_insured = true;
          //更新建議書資訊
          tempNowSelectProposal.insured_name =
            crmMapList[mcInsured_id].insured_name;
          tempNowSelectProposal.insured_gender =
            crmMapList[mcInsured_id].insured_gender;
          tempNowSelectProposal.insured_age =
            crmMapList[mcInsured_id].insured_age;
          tempNowSelectProposal.insured_birthday =
            crmMapList[mcInsured_id].insured_birthday || "";
        }
        //開始判斷建議書主約~附約被保險人
        for (let i = 0; i < tempNowSelectProposal.mc_prod_list.length; i++) {
          //幫主約壓上更新後的資料，這邊不需要重算保費，因為存檔的時候會計算
          let mc = tempNowSelectProposal.mc_prod_list[i];
          mc.insured_name = crmMapList[mcInsured_id].insured_name;
          mc.insured_gender = crmMapList[mcInsured_id].insured_gender;
          mc.insured_age = crmMapList[mcInsured_id].insured_age;
          mc.insured_birthday = crmMapList[mcInsured_id].insured_birthday;
          for (let j = 0; j < mc.sc_prod_list.length; j++) {
            let sc = mc.sc_prod_list[j];
            let scInsured_id = sc.insured_id;
            //如果附約被保險人搬家或被砍掉
            if (!crmMapList[scInsured_id]) {
              //被保人離開不在這個家戶 因此做例外處理
              let theCust = await getCustInfo(
                this.$store.state.userInfo.id,
                this.$store.state.userInfo.id,
                scInsured_id
              );
              if (theCust.body.customer) {
                //有找到
                crmMapList[scInsured_id] = {
                  insured_name: theCust.body.customer.name,
                  insured_birthday: theCust.body.customer.birthday || "",
                  insured_gender: theCust.body.customer.sex,
                  insured_age: theCust.body.customer.age + "",
                };
              } else {
                //找不到
                this.$toast.info({
                  title: `${sc.insured_name}找不到資料`,
                });
              }
            }
            if (
              sc.insured_name != crmMapList[scInsured_id].insured_name ||
              sc.insured_gender != crmMapList[scInsured_id].insured_gender ||
              sc.insured_age != crmMapList[scInsured_id].insured_age ||
              sc.insured_gender != crmMapList[scInsured_id].insured_gender ||
              sc.insured_birthday != crmMapList[scInsured_id].insured_birthday
            ) {
              needShowChangePopup = true;
              this.oldCrmMapList[scInsured_id] =
                this.oldCrmMapList[scInsured_id] || {};
              this.oldCrmMapList[scInsured_id].insured_name = sc.insured_name;
              this.oldCrmMapList[scInsured_id].insured_birthday =
                sc.insured_birthday || "";
              this.oldCrmMapList[scInsured_id].insured_gender =
                sc.insured_gender;
              this.oldCrmMapList[scInsured_id].insured_age =
                sc.insured_age + "";
              this.oldCrmMapList[scInsured_id].is_scInsured = true;
              //幫附約壓上更新後的資料並重新計算保費
              sc.insured_name = crmMapList[scInsured_id].insured_name;
              sc.insured_gender = crmMapList[scInsured_id].insured_gender;
              sc.insured_age = crmMapList[scInsured_id].insured_age;
              sc.insured_birthday =
                crmMapList[scInsured_id].insured_birthday || "";
              //計算
              try {
                let { premium } = await this.$mfAPI.MFC0_1000__getPremium({
                  ...sc,
                  pay_prd: sc.pay_prd,
                  pol_period: mc.pol_period,
                  pay_freq: mc.pay_freq,
                  insured_age: crmMapList[scInsured_id].insured_age,
                  insured_gender: crmMapList[scInsured_id].insured_gender,
                });
                sc.premium = premium;
              } catch {
                //取不到保費，考慮是否直接把該附約過濾掉
              }
            }
            ///
          }
        }
        if (needShowChangePopup) {
          mode = "edit";
          this.changePopupHandler = true;
          this.tempNowSelectProposal = _.cloneDeep(tempNowSelectProposal);
          this.toHandler = to(tempNowSelectProposal);
        } else {
          to(tempNowSelectProposal)();
        }
      };

      if (this.nowSelectProposal.insured_id != "") {
        await customStatusCheck();
      }

      if (!isStopSale && mode != "edit") {
        to(tempNowSelectProposal)();
        this.$router.push("/mf/performace/recommendedProduct");
      }
    },
    selectContractDateHandler($event) {
      this.nowSelectProposal = $event;
      this.performanceDisable(this.nowSelectProposal);
    },
    performanceDisable(data) {
      if (data.mc_prod_list.length !== 0) {
        this.isDisable = false;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    //新增頁才做判斷
    if (to.path == "/mf/performace") {
      if (this.isEdit) {
        //如果是修建議書則直接進去
        next();
      } else {
        //直接按頁籤需要帶入
        let MfViewing = this.$store.getters.MfViewing;
        if (MfViewing.inputType == "noId") return next();
        this.$store.commit(
          "update_MfEditing",
          _.cloneDeep({
            insurer: MfViewing.insurer,
            insured: MfViewing.insured,
            inputType: MfViewing.inputType,
            sameInsurer: MfViewing.sameInsurer,
          })
        );
        next();
      }
    } else {
      next();
    }
  },
};
</script>

<style lang="scss">
.queryDetail {
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  .selectInsered {
    border-bottom: solid 1px #c2c4c7;
    &__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .inseredTab {
        width: 166px;
        display: flex;
        padding: 10px;
        border-radius: 25px;
        border: solid 1px #c2c4c7;
        background-color: #fff;
        cursor: pointer;
        &__name {
          flex-grow: 1;
          text-align: center;
        }
        &.active {
          border: solid 1px #f58818;
          background-color: #feeedd;
        }
      }
    }
  }
  &__title {
    display: flex;
    align-items: center;
    &--tag {
      width: 8px;
      height: 24px;
      margin: 0 4px 1px 0;
    }
  }
}
.queryDetail__empty {
  min-height: 55vh;
  margin-bottom: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #323a45;
}
</style>
